import React from "react";
import Joyride from "react-joyride";

export default function HelpTour({ show, steps, ...props }) {
  if (!show) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      continuous
      showProgress
      disableScrolling
      showSkipButton={false}
      hideBackButton={true}
      locale={{ back: "Indietro",
                close: "Chiudi",
                last: "Fine",
                next: "Prossimo",
                open: "Mostra aiuto",
                skip: "Esci"}}
      styles={{options: {primaryColor: "#2a7bbf",zIndex: 2000,}}}
      floaterProps={{styles: {wrapper: {zIndex: 2000},},}}
      {...props}
    />
  );
}
